module.exports = __webpack_public_path__ + "static/media/section.86084a2f.png";